module.exports = __webpack_public_path__ + "img/MyGymChecker-Logomark-PNG-WhiteBlue.6c0f8134.png";